function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar, Menu, MenuButton, MenuItem, MenuPopover } from '@arc/frontend/ui-common';
import { su } from '@arc/frontend/ui-theme';
import { useAuth, useMutationLogout } from '@arc/frontend/util-auth';
import { UserProfileModal } from './UserProfileModal';
const styles = {
  avatarButton: process.env.NODE_ENV === "production" ? {
    name: "7wcw5s",
    styles: "cursor:pointer;width:3rem;margin-right:0.25rem;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:flex-end;padding-bottom:0.5rem"
  } : {
    name: "19af4zu-avatarButton",
    styles: "cursor:pointer;width:3rem;margin-right:0.25rem;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:flex-end;padding-bottom:0.5rem;label:avatarButton;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
export function UserMenu() {
  const {
    t
  } = useTranslation(['common', 'login']);
  const {
    user
  } = useAuth();
  const {
    mutate: logout
  } = useMutationLogout();
  const [userProfileModalOpen, toggleProfileModal] = useReducer(state => !state, false);
  return <>
			<Menu trigger={<MenuButton css={styles.avatarButton} data-testid="profile-icon-button">
						<Avatar name={user.name} size="small" />
						<div css={su.text2xs}>{user?.name?.split(' ')?.[0]}</div>
					</MenuButton>}>
				<MenuPopover data-testid="profile-icon-menu">
					<MenuItem onSelect={toggleProfileModal} data-testid="profile">
						{t('sections.profile')}
					</MenuItem>
					<MenuItem onSelect={() => logout({
          noReturn: true
        })} data-testid="logout">
						{t('login:action Log out')}
					</MenuItem>
				</MenuPopover>
			</Menu>
			<UserProfileModal show={userProfileModalOpen} onCancel={toggleProfileModal} onSave={toggleProfileModal} />
		</>;
}